import React from 'react'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'
import { useSelector } from 'react-redux'

import { useUnitTypeLabel } from '../../../../../../hooks/remainingBudgetHooks'
import { getIsBudgetAllocationType } from '../../../../../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/helpers'
import { getGamInventoryType, inventoryTypes } from '../../../../../../helpers'
import { AD_INVENTORY } from '../../../../../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'

import { rightSelector } from '../../../../../../../../../../../modules/selectors/rights'

import useSelectedItemsTableStyles from '../../../../../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/InventoryAccessAndAllocationSection/SubAllocationTables/styles'
import useStyles from '../styles'

const RightInventoryTableHeader = () => {
  const { t } = useTranslation()

  const selectedItemsTableClasses = useSelectedItemsTableStyles()
  const classes = useStyles()

  const right = useSelector(rightSelector)
  const unitTypeLabel = useUnitTypeLabel()
  const isBudgetAllocationType = getIsBudgetAllocationType(right)
  const inventoryType = getGamInventoryType(right[AD_INVENTORY])

  const inventoryLabel = inventoryType === inventoryTypes.placements ? 'Ad placement' : 'Ad unit'

  return (
    <div
      className={classnames(
        selectedItemsTableClasses.row,
        selectedItemsTableClasses.container,
        selectedItemsTableClasses.headerRow
      )}
    >
      <p className={classnames(selectedItemsTableClasses.label)}>{t(inventoryLabel)}</p>
      <p className={classnames(selectedItemsTableClasses.inlineField, classes.textCenter, classes.remainingBudget)}>
        {t('Remaining Budget')}
      </p>
      <p className={classnames(selectedItemsTableClasses.inlineField, classes.textCenter, classes.capitalize)}>
        {isBudgetAllocationType ? t(`Budget`) : t(`${unitTypeLabel} Budget`)}
      </p>
      <div className={selectedItemsTableClasses.selectedValueRemove}>{/*placeholder*/}</div>
    </div>
  )
}

export default RightInventoryTableHeader
